module.exports = __webpack_public_path__ + "img/syf.012effba.jpg";